import React, { useState, useEffect, useRef } from 'react';
import '../styles/banner.scss';
import { useHistory, useParams } from "react-router-dom";
import { Typography, Dialog, DialogTitle, DialogContent, Slide, useMediaQuery, AppBar, Button, Box, Collapse, Toolbar, Tooltip, IconButton, Menu, MenuItem, Avatar, ListItemIcon, Divider, Drawer, List, ListItem, ListItemAvatar, ListItemButton, ListSubheader, ListItemText, FormControl, Autocomplete, InputLabel, NativeSelect, Select } from '@mui/material';
import { IconX, IconSearch, IconUsers, IconMessageShare, IconLogout2, IconUser, IconInfoCircle, IconLockSquareRounded, IconSend, IconListCheck, IconUserSquareRounded, IconUserFilled, IconChevronDown, IconChevronUp, IconBuilding, IconBriefcase, IconMapPin, IconPhone, IconMail, IconLock, IconEye, IconEyeOff, IconLogin, IconCheck, IconArrowForward, IconArrowLeft, IconArrowRight, IconUsersGroup } from '@tabler/icons-react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { logPageViews, UserSession } from '../Services/LoginService';
import InvalidLicense from '../components/InvalidLicense'
import { useTheme } from '@mui/material/styles';
// import MetaTags from 'react-meta-tags';
import { Helmet } from 'react-helmet';
import SearchBox from './searchbox';
import { Row, Col, Container } from 'react-bootstrap';
import { useThemeManager } from '../Context/ThemeManager';


const Banner = () => {

  const { theme} = useThemeManager();
  const history = useHistory();

  //   const handleLogoutClick = async () => {
  //     document.getElementById('loaderPage').style.display = 'flex'
  //     document.getElementById("loaderPage").style.zIndex = "1400";
  //     console.log("Logout clicked");
  //     await logPageViews("Logout");

  //     const sessionId = localStorage.getItem("sessionId");
  //     const userId = localStorage.getItem("userId");

  //     if (sessionId && userId) {
  //       try {
  //         const res = await UserSession(
  //           'Logout',
  //           sessionId,
  //           '',
  //           userId,
  //           '',
  //           '',
  //           '',
  //           '',
  //           '',
  //           '',
  //           ''
  //         );

  //         console.log("UserSession raw response:", res);

  //         // Check if there are errors in the response (such as missing token)
  //         if (res.data && res.data.errors) {
  //           console.log("Session error detected:", res.data.errors);

  //           // Proceed with logout if there are validation errors
  //           localStorage.clear();
  //           history.push('/login?logout=true');
  //           handleMenuClose(); // if defined
  //           document.getElementById('loaderPage').style.display = 'none'
  //         } else {
  //           console.log("Session still active.");
  //         }
  //       } catch (error) {
  //         console.error("Logout error:", error);
  //       }
  //     }
  //   };


  // const [openInvalidModal, setOpenInvalidModal] = useState(false);
  // useEffect(() => {

  //   CheckUserSessionTime()
  //   async function CheckUserSessionTime() {
  //     if(localStorage.getItem("sessionId") !== null && localStorage.getItem("userId") !== null)
  //       {
  //           if((await UserSession('Check',localStorage.getItem("sessionId"),'',localStorage.getItem("userId"),'','','','','','','')).data == false)
  //               {
  //                 setOpenInvalidModal(true);
  //                  localStorage.clear()
  //               }
  //       }

  //   }
  // }, []);


  const handleLogoutClick = () => {
    //    localStorage.removeItem('token');
    document.getElementById('loaderPage').style.display = 'flex'
    document.getElementById("loaderPage").style.zIndex = "1400";
    logPage()
    async function logPage() {
      await logPageViews("Logout")
    }
    CheckUserSession()
    async function CheckUserSession() {
      if (localStorage.getItem("sessionId") !== null && localStorage.getItem("userId") !== null) {
        if ((await UserSession('Logout', localStorage.getItem("sessionId"), '', localStorage.getItem("userId"), '', '', '', '', '', '', '')).data.isExceeded == false) {

          var ee = localStorage.getItem('email');
          var pp = localStorage.getItem('pass');
          var rr = localStorage.getItem('remember');


          //alert(ee)
          localStorage.clear();
          if (rr === 'true') {
            localStorage.setItem('email', ee);
            localStorage.setItem('pass', pp);
            localStorage.setItem('remember', rr);
          }
          handleMenuClose();

          // document.getElementById('loaderPage').style.display = 'none'
          // history.push('/login?logout=true')
          window.location.href = '/login?logout=true'
        } else {

        }
      }

    }
  };
  const [openInvalidModal, setOpenInvalidModal] = useState(false);
  const [sessionResult, setSessionResult] = useState(null);
  const [sessionResultMessage, setSessionResultMessage] = useState("");
  const [Countryver, setCountryver] = useState([]);
  const abbpi_ref = React.useRef(localStorage.getItem('countryversion'));
  const [selectedValue, setSelectedValue] = useState('');
  const [items, setItems] = useState(() => {
  const savedItems = localStorage.getItem("countryversionList");
  const parsed = savedItems ? JSON.parse(savedItems) : [];

  return parsed.map((item) => ({
      ...item,
      abbreviation:
        item.CountryName === "New Zealand"
          ? "NZ"
          : item.CountryName === "Australia"
          ? "AU"
          : ""
    }));
  });


  const [itemCountry, setCountry] = useState(() => {
    const savedItems = localStorage.getItem('Activecountryversion');
    // Parse the string into an array, default to an empty array if null
    return savedItems ? savedItems : '';
  });

  const handleChange = (event) => {
    //console.log(event.target.value);
    document.getElementById("loaderPage").style.display = "flex";
        document.getElementById("loaderPage").style.zIndex = "1400";
    localStorage.setItem('Activecountryversion', event.target.value);
    localStorage.setItem('gateway', 'false');

    // items.map((name) => (


    //               //name.CountryName
    //               if(name.CountryName == event.target.value)
    //               {

    //               }

    //           ))
    items.map(num => { // Use curly braces
      
      if (num.CountryName == event.target.value) {
        event.target.value == 'New Zealand' ?  localStorage.setItem('gateway', 'false') : localStorage.setItem('gateway', num.ImGateWay.toLowerCase())
        //localStorage.setItem('gateway', num.ImGateWay.toLowerCase());
        localStorage.setItem('subscriptionType', num.SubType);
        localStorage.setItem('subscriptionStart', num.SubcriptionStartDate);
        localStorage.setItem('subscriptionEnd', num.SubcriptionEndDate);
        localStorage.setItem('licenseCount', num.LicenseCount);
      }
    });
    
    // window.location.reload();
    window.location.href = '/Home';
    // document.getElementById("loaderPage").style.display = "none";
    // localStorage.setItem('gateway', tokenResponse.data.isImGateway);
    //     localStorage.setItem('subscriptionType', tokenResponse.data.eStoreWebModels[0].subType);
    //     localStorage.setItem('subscriptionStart', tokenResponse.data.eStoreWebModels[0].subcriptionStartDate);
    //     localStorage.setItem('subscriptionEnd', tokenResponse.data.eStoreWebModels[0].subcriptionEndDate);
    //     localStorage.setItem('licenseCount', tokenResponse.data.eStoreWebModels[0].licenseCount);
  };

  useEffect(() => {

    // if (localStorage.getItem('countryversion') != null) {
    //   alert(localStorage.getItem('countryversion'))
    // }

    // console.log(localStorage.getItem('countryversion'));
    //console.log(sessionResult != null)
    if (sessionResult !== null) {
      //console.log(sessionResult.data);
      if (sessionResult.data.isExceeded == false) {
        setSessionResultMessage(sessionResult.data.message)
        if (sessionResult.data.message == "") {
          localStorage.clear()
          window.location.reload();
        } else {
          setOpenInvalidModal(true);
        }
      } else {
        if (sessionResult.data.token != "") {
          
          localStorage.setItem('token', sessionResult.data.token);
          localStorage.setItem('refreshToken', sessionResult.data.refreshToken);
          
          if(sessionResult.data.token == null)
          {
            window.location.reload();
          }
        
          if (sessionResult.data.isRefresh) {

            //alert(sessionResult.data.sessionId)
            localStorage.setItem('sessionId', sessionResult.data.sessionId);
            window.location.reload();
          }
        }
       

      }


    } else {
      //console.log("null")
     
    }


  }, [sessionResult]);


  const [itemsessionId, setsessionId] = useState(() => {
    const savedItems = localStorage.getItem('sessionId');
    return savedItems ? savedItems : '';
  });
  const [itemuserId, setuserId] = useState(() => {
    const savedItems = localStorage.getItem('userId');
    return savedItems ? savedItems : '';
  });
  const [itemrefreshToken, setrefreshToken] = useState(() => {
    const savedItems = localStorage.getItem('refreshToken');
    return savedItems ? savedItems : '';
  });
  const [itemtoken, settoken] = useState(() => {
    const savedItems = localStorage.getItem('token');
    return savedItems ? savedItems : '';
  });

  useEffect(() => {

    CheckUserSessionTime()
    //console.log(itemtoken)
    async function CheckUserSessionTime() {
    
        setSessionResult(await UserSession('Check', itemsessionId, '', itemuserId, '', '', '', '', '', '', '', itemrefreshToken, itemtoken))
      
     
      // if(localStorage.getItem("sessionId") !== null && localStorage.getItem("userId") !== null)
      //   {
      //       if((await UserSession('Check',localStorage.getItem("sessionId"),'',localStorage.getItem("userId"),'','','','','','','',localStorage.getItem("refreshToken"),localStorage.getItem("token"))).data == false)
      //           {
      //             setOpenInvalidModal(true);
      //             localStorage.clear()
      //           }
      //   }

    }
  }, []);



  const handleLogoClick = () => {
    history.push('/Home'); // Always redirect to login
  };


  const [openDrawer, setDrawerOpen] = React.useState(false);
  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };
  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const muiTheme = useTheme();
  const isLargeScreen = useMediaQuery(muiTheme.breakpoints.up('md'));
  const handleClick = (event) => {
    if (isLargeScreen) {
      if (anchorEl) {
        setAnchorEl(null);
      } else {
        setAnchorEl(event.currentTarget);
      }
    } else {
      // This logic prevents unnecessary re-renders
      setDrawerOpen(prevState => !prevState);
    }
  };
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    // Fetch IP address from ipify API
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        setIpAddress(data.ip);
        localStorage.setItem('ip', data.ip); // Store IP address in localStorage
      })
      .catch(error => console.error('Error fetching IP address:', error));
  }, []);

  const fullName = localStorage.getItem('fullName') || 'Guest'; // Get full name of user
  const email = localStorage.getItem('email') || 'Guest'; // Get full name of user
  const firstLetter = fullName.charAt(0).toUpperCase();
  const isLgScreen = useMediaQuery('(min-width:1024px)');

  //Search Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSearch = (button) => {

    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  const activeCountry = localStorage.getItem("Activecountryversion");


  return (<>
    {openInvalidModal && <div> <InvalidLicense message={sessionResultMessage} /></div>}
    <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
    <AppBar
      position="fixed"
      id="navBanner"
      style={{ background: theme.bannerGradient }}
    >
      <Toolbar>
        <div id="logo" className='d-flex align-items-center gap-1'>
          <Tooltip title={`Your IP address is ${ipAddress || localStorage.getItem('ip')}`}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleLogoClick} >
              <img src={activeCountry === "Australia" ?  "/Logo.svg" : "/Drugs4dent.svg"}  id="logo-img" alt="Logo" />
            </IconButton>
          </Tooltip>
          {items.length === 1 ? (
            /* Render plain text when there is only one item */
            <Box
              sx={{
                color: theme.dropdownText,
                fontWeight: "bold",
                fontSize: "16px",
                display: "inline-flex",
                alignItems: "center",
                height: "fit-content"
              }}
            >
              {isLgScreen ? items[0].CountryName : items[0].abbreviation}
            </Box>
          ) : (
            /* Your existing FormControl + Select code for multiple items */
            <FormControl variant="filled" size="small">
                <Select
                  value={itemCountry} // Hardcoded for visual
                  disableUnderline // Removes the default line if you want it super clean
                  onChange={handleChange}
                  renderValue={(selected) => {
                    const selectedItem = items.find(
                      (item) => item.CountryName === selected
                    );
                    return selectedItem ? isLgScreen ? selectedItem.CountryName : selectedItem.abbreviation : selected;
                  }}
                  sx={{
                    color: theme.primaryTitle,
                    fontWeight: "bold",
                    fontSize: isLgScreen ? "16px" : "12px",
                    backgroundColor: "#fff",
                    borderRadius: "8px",

                    "&:hover": {
                      backgroundColor: "#fff"
                    },

                    "&.Mui-focused": {
                      backgroundColor: "#fff"
                    },

                    "& .MuiSvgIcon-root": {
                      color: theme.primaryTitle
                    },

                    "& .MuiSelect-select": {
                      paddingTop: "4px",
                      paddingBottom: "4px",
                      paddingLeft: "12px",
                      paddingRight: "32px !important"
                    }
                  }}
                  MenuProps={{
                      sx: {
                          "& .MuiList-root": { 
                              paddingTop: 0, 
                              paddingBottom: 0 
                          },
                          "& .MuiMenuItem-root": { 
                              fontSize: "14px",
                              padding: "10px 20px" // Gives the list items some breathing room too
                          }
                      }
                  }}
                >
                    {items.map((item) => (
                      <MenuItem key={item.CountryName} value={item.CountryName}>
                        {item.CountryName}
                      </MenuItem>
                    ))}
                </Select>
          </FormControl>
          )}
        </div>

        <div id="bannerButtons" className='d-flex align-items-center gap-2'>
          


          {!window.location.pathname.toLowerCase().includes('/home') &&
            !isLargeScreen && (<>
              <IconButton
                onClick={handleSearch}
                sx={{         // Make it perfectly circular
                  color: 'white',
                  p:0
                }}
              >
                <IconSearch />
              </IconButton>
              <Dialog TransitionComponent={Slide}
                fullScreen
                transitionDuration={300} open={isModalOpen} onClose={handleCloseModal} classes={{ paper: 'bannerSearchModal', container: 'dialog-top-center' }} >
                {/* <DialogTitle id="headline-container">
                  <img src='/Search.svg' style={{maxHeight: "40px", height: "auto"}} alt="Logo" />
                    <span style={{fontSize: "12px"}}>Search MIMS Drugs4dent&#174;</span>
                </DialogTitle> */}
                <AppBar sx={{ position: 'relative', bgcolor: "white" }}>
                  <Toolbar sx={{ alignItems: "center", justifyContent: "space-between" }}>
                    <div className='d-flex align-items-center'>
                      <img src='/Search.svg' style={{ maxHeight: "28px", height: "auto" }} alt="Logo" />
                      <Typography sx={{ ml: 2, flex: 1, color: "#0262AB", fontSize: 16, whiteSpace: 'nowrap', }} variant="h6" component="div">
                        Search MIMS Drugs4dent&#174;
                      </Typography>
                    </div>
                    <IconButton
                      edge="end"
                      color="default"
                      onClick={handleCloseModal}
                      aria-label="close"
                    >
                      <IconX />
                    </IconButton>
                  </Toolbar>
                </AppBar>
                <DialogContent sx={{ p: 1 }}>
                  <div id="search" style={{ fontSize: 12, }}>
                    <SearchBox handleCloseModal={handleCloseModal} toggleDrawer={toggleDrawer} />
                  </div>
                </DialogContent>
              </Dialog>
            </>
            )
          }

          {!window.location.pathname.toLowerCase().includes('/feedback') && (
            isLargeScreen ? (
              <Button
                id="feedbackButton"
                variant="outlined"
                color="primary"
                onClick={() => history.push('/feedback')}
                startIcon={<IconMessageShare />}
              >
                Send Feedback
              </Button>
            ) : (
              <IconButton
                variant="outlined"
                onClick={() => history.push('/feedback')}
                sx={{       // Make it perfectly circular
                  color: 'white',
                  p:0,
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)' // Optional hover effect
                  }
                }}
              >
                <IconMessageShare />
              </IconButton>

            )
          )}


          {/* Large screen menu */}
          <IconButton
            edge="end"
            color="inherit"
            aria-label="user-menu"
            onClick={handleClick}
            id="avatarButton"

          >
            <Avatar alt="User">
              <IconUserFilled color={theme.primaryColor}/>
            </Avatar>
          </IconButton>

          <Menu id="bannerMenu" anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
            <MenuItem className="menuItem" sx={{ color: theme.primaryTitle }}>
              {fullName}
              <span>{email}</span>
            </MenuItem>
            <Divider sx={{ my: 4, borderBottomWidth: 1, borderColor: '#727272' }} />
            <MenuItem className="menuItem" onClick={() => history.push('/MyAccount')}>
              <ListItemIcon>
                <IconUser />
              </ListItemIcon>
              Manage Account
            </MenuItem>
            {localStorage.getItem('userType') == 2 && localStorage.getItem('groupId') != "" &&
              <MenuItem className="menuItem" onClick={() => history.push('/MyGroupUsers')}>
                <ListItemIcon>
                  <IconUsers />
                </ListItemIcon>
                Users Group
              </MenuItem>
            }
            <MenuItem className="menuItem" onClick={handleLogoutClick}>
              <ListItemIcon>
                <IconLogout2 />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>

          {/* Small screens menu drawer */}
          <Drawer id="bannerDrawerMobile" open={openDrawer} anchor={'right'} sx={{ '& .MuiDrawer-paper': { width: '68vw', }, '&.MuiDrawer-root': { zIndex: 1300 } }} ModalProps={{ keepMounted: true }}>
            <Box p={2} sx={{ height: '100%', paddingBottom: 4 }}> {/* Ensure the Box has a defined height */}
              <IconButton onClick={handleDrawerClose}
                sx={{
                  position: 'absolute',
                  top: 16,
                  right: 16,
                  color: 'grey.500',
                }}
              >
                <IconX sx={{ fontSize: 32 }} />
              </IconButton>
              <List sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <ListItem>
                  <ListItemText
                    primary={fullName}
                    primaryTypographyProps={{ style: { fontWeight: 'bold', fontSize: '24px', color: '#0262AB' } }}
                    secondary={email}
                    secondaryTypographyProps={{ style: { fontSize: '20px', color: '#727272' } }}
                  />
                </ListItem>
                <Divider sx={{ my: 4, borderBottomWidth: 1, borderColor: '#727272' }} />
                <List component="div" className='subList'
                  aria-labelledby="nested-list-subheader"
                  subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                      ACCOUNT
                    </ListSubheader>
                  }
                  sx={{ mb: 4 }}
                >
                  <ListItemButton onClick={() => history.push('/MyAccount')}>
                    <ListItemIcon> <IconUser /> </ListItemIcon>
                    <ListItemText primary={'Manage Account'} />
                  </ListItemButton>
                  {localStorage.getItem('userType') === 2 && localStorage.getItem('groupId') != "" &&
                    <ListItemButton onClick={() => history.push('/MyGroupUsers')}>
                      <ListItemIcon> <IconUsers /> </ListItemIcon>
                      <ListItemText primary={'Users Group'} />
                    </ListItemButton>
                  }
                </List>

                <List component="nav" className='subList'
                  aria-labelledby="nested-list-subheader"
                  subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                      GENERAL
                    </ListSubheader>
                  }
                >
                  <ListItem className="itemList" disablePadding>
                    <ListItemButton onClick={() => history.push('/about')}>
                      <ListItemIcon> <IconInfoCircle /> </ListItemIcon>
                      <ListItemText primary="About" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem className="itemList" disablePadding>
                    <ListItemButton onClick={() => history.push('/privacy')}>
                      <ListItemIcon> <IconLockSquareRounded /> </ListItemIcon>
                      <ListItemText primary="Privacy" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem className="itemList" disablePadding>
                    <ListItemButton onClick={() => history.push('/feedback')}>
                      <ListItemIcon> <IconMessageShare /> </ListItemIcon>
                      <ListItemText primary="Feedback" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem className="itemList" disablePadding>
                    <ListItemButton onClick={() => history.push('/terms')}>
                      <ListItemIcon> <IconListCheck /> </ListItemIcon>
                      <ListItemText primary="Terms & Conditions" />
                    </ListItemButton>
                  </ListItem>
                </List>
                <div style={{ flexGrow: 1 }}></div>
                <Divider sx={{ my: 4, borderBottomWidth: 1, borderColor: '#727272' }} />
                <ListItem className="itemList" disablePadding>
                  <ListItemButton className="itemButton" onClick={handleLogoutClick}>
                    <ListItemIcon>
                      <IconLogout2 />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                  </ListItemButton>
                </ListItem>
                <ListItem className="itemList " >
                  <ListItemText primary="&copy; MIMS Australia. All rights reserved." />
                </ListItem>
              </List>
            </Box>
          </Drawer>
        </div>

      </Toolbar>
    </AppBar>

  </>);
}

export default Banner;